import { render, staticRenderFns } from "./create-transaction-disbursement.vue?vue&type=template&id=c3ada9ce&scoped=true&"
import script from "./create-transaction-disbursement.vue?vue&type=script&lang=js&"
export * from "./create-transaction-disbursement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ada9ce",
  null
  
)

export default component.exports